import * as React from "react"
import {createSearchParams, NavLink, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {ArrowCircleLeft, GppGood, PlayCircle} from "@mui/icons-material";
import {Box, Checkbox, Dialog, DialogContent, FormControlLabel, Tab, Tabs} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import Divider from "@mui/material/Divider";
import {useDispatch} from "react-redux";
import {useShowMessageComponent} from "../../assets/js/main";
import HandleFetchData from "../../plugin/HandleFetchData";


export default function Divar() {
  const {t, i18n} = useTranslation()
  const {fetchData} = HandleFetchData()
  const {showMessageComponent} = useShowMessageComponent()

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [loginTryDialog, setLoginTryDialog] = React.useState(false)
  const [rulesDialog, setRulesDialog] = React.useState(false)
  const [rulesDialog1, setRulesDialog1] = React.useState(searchParams.get('showRules'))
  const [videoDialog, setVideoDialog] = React.useState(false)
  const [checkedRules, setCheckedRules] = React.useState(searchParams.get('showRules'))
  const [checkBoxNotShowPopupDivar, setCheckBoxNotShowPopupDivar] = React.useState(false)
  const [value, setValue] = React.useState('0');
  const divarIncomId = searchParams.get('state')
  // const showRules = searchParams.get('showRules')
  const divarCallback = localStorage.getItem('d-callback')

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    // setRulesDialog(!localStorage.getItem("notShowPopupDivar"))

    localStorage.setItem("d-callback", "https://open-platform-redirect.divar.ir/completion")

  }, [])

  // اضافه کردن Attribute به dom پروژه
  document.documentElement.setAttribute('lang', i18n.language);
  document.documentElement.setAttribute('dir', i18n.dir(i18n.language));

  const handleOrderValidate = () => {
    if (divarIncomId && checkedRules) {
      navigate({
        pathname: "/divar/singleOrder",
        search: createSearchParams({
          state: divarIncomId
        }).toString()
      });
      localStorage.setItem("token-id", searchParams.get('state'))
      setRulesDialog1(false)
    } else if (!divarIncomId) {
      showMessageComponent('برای رفتن به مرحله بعد باید آی دی شما معتبر باشد', 'error')
    } else if (!localStorage.getItem("token")) {
      showMessageComponent('مجددا وارد شوید', 'error')
    } else {
      showMessageComponent('خواندن قوانین اجباری می باشد', 'error')
    }

  }

  return (
     <>
       <div className="divarPage">
         <div className="container">
           <div className="row">
             <div className="col-12 col-lg-3 col-xl-4"/>
             <div className="col-12 col-lg-6 col-xl-4 ">

               <div className="logo">
                 <NavLink to=''>
                   <img src={process.env.REACT_APP_SITE === 'amnito' ? '/amnito.png' : '/Logo.png'} alt=""/>
                 </NavLink>
               </div>

               {/*               <div className="main-title">*/}
               {/*                 <p>{t("homeDesktop.s1.t18")}<span>{t("homeDesktop.s1.t19")}</span></p>*/}
               {/*                 <span>{t("homeDesktop.s1.t20")}<p>{t("homeDesktop.s1.t21")}!</p></span>*/}
               {/*               </div>*/}

               {/*               <div className="service-title">*/}
               {/*                 <h3>لذت خرید و فروش*/}
               {/*                   <br/>*/}
               {/*                   اینترنتی با سرویس امنیتو.</h3>*/}
               {/*               </div>*/}

               {/*               <div className="service-desc">*/}
               {/*                  <span>*/}
               {/*در صورت انتخاب سرویس امنیتو مبلغ کالا در حساب امانی پستِکس تا زمان تحویل و بررسی کالا توسط گیرنده قبل از انتقال وجه به حساب فرستنده نگهداری می شود*/}
               {/*                    تحویل مرسوله درب منزل به خریدار.*/}
               {/*                                        <br/>*/}
               {/*                    مشتری گرامی برای کالا با ارزش ریالی بالای ۲۰میلیون تومان و وزن بالای ۳۰ کیلوگرم سرویس امینتو قادر به ارائه خدمات نمی‌باشد*/}
               {/*                    <br/>*/}
               {/*تعهد غرامت ناشی از عملیات پستی بعهده پستِکس است.*/}
               {/*           </span>*/}
               {/*               </div>*/}

               <h3 className="mb-3">توجه!</h3>
               <span className="mb-2">
              درصورتی که اطلاعات از فرستنده ندارید به چت دیوار مراجعه کنید
             </span>

               <p className="mb-2" style={{fontSize: '18px', textAlign: 'right'}}>اطلاعات لازم:</p>
               <ul>
                 <li>نام و نام خانوادگی</li>
                 <li>شماره تماس</li>
                 <li>آدرس</li>
                 <li>وزن محصول</li>
                 <li>ابعاد محصول</li>
               </ul>

               {/*<div className="container">*/}
               {/*  <div className="row">*/}
               {/*    <div className="col-12 col-md-12">*/}
               {/*<div className="btnGroup_blue mt-0 mx-0 mb-2" style={{justifyContent: 'center'}}>*/}
               {/*  <button type="button" className="btnFill  mx-0" onClick={() => setRulesDialog(false)} id="closeRulesDialog">*/}
               {/*    <span style={{color: '#ffffff'}}>اطلاعات را دارم ادامه سفارش کالا</span>*/}
               {/*    <GppGood style={{fontSize: '30px', color: '#ffffff'}}/>*/}
               {/*  </button>*/}
               {/*</div>*/}
               {/*    </div>*/}
               {/*    <div className="col-12 col-md-12">*/}
               {/*      <div className="btn-divar mt-0 mx-0 mb-2 " style={{justifyContent: 'center'}}>*/}
               {/*        <a href={divarCallback} className="btnFill mx-0">*/}
               {/*          <span>اطلاعات را ندارم بازگشت به چت دیوار</span>*/}
               {/*          <img src={require('../../assets/img/divar.png')} alt="divar"/>*/}
               {/*        </a>*/}
               {/*      </div>*/}
               {/*    </div>*/}
               {/*  </div>*/}
               {/*</div>*/}

               {/*<div className="checkBox_yellow">*/}
               {/*  <FormControlLabel control={<Checkbox*/}
               {/*     checked={checkBoxNotShowPopupDivar}*/}
               {/*     onChange={e => {*/}
               {/*       setCheckBoxNotShowPopupDivar(e.target.checked)*/}
               {/*       localStorage.setItem('notShowPopupDivar', e.target.checked)*/}
               {/*     }}/>}*/}
               {/*                    label="دیگه این پیام رو به من نمایش نده"/>*/}
               {/*</div>*/}

               {/*<span style={{textAlign: 'right'}}>درصورت تمایل فرستنده هم میتواند ثبت سفارش کند و گیرنده از قسمت سفارشات دیگران برای من پرداخت را انجام دهد</span>*/}

                   <div className="d-inline-block m-0">
                     <div className="d-flex">
                       <Checkbox checked={checkedRules} onChange={(e) => setCheckedRules(e.target.checked)} id="checkedRules"/>
                       <div className="_btnGroup_light m-0">
                         <button className="btnEmpty" onClick={() => {
                           setRulesDialog1(true)
                           setCheckedRules(true)
                         }} id="checkedRules">
                           <span>مطالعه قوانین</span>
                           <ArrowCircleLeft/>
                         </button>
                       </div>
                     </div>
                   </div>
                   <div className="_btnGroup_light d-inline-block m-0" style={{transform: 'translateY(-8px)'}}>
                     {/*<button className="btnEmpty" onClick={() => {*/}
                     {/*  setRulesDialog1(true)*/}
                     {/*  setCheckedRules(true)*/}
                     {/*}} id="checkedRules">*/}
                     {/*  <span>مطالعه قوانین</span>*/}
                     {/*  <ArrowCircleLeft/>*/}
                     {/*</button>*/}
                     <button className="btnEmpty" onClick={() => setVideoDialog(true)} id="openVideoDialog">
                       <span>مشاهده ویدیو آموزشی</span>
                       <PlayCircle/>
                     </button>
                   </div>



               <div className="btnGroup_blue mt-0 mx-0 mb-2" style={{justifyContent: 'center'}}>
                 <button type="button" className="btnFill w-100 mx-0" onClick={handleOrderValidate} id="handleOrderValidate">
                   <span style={{color: '#ffffff'}}>اطلاعات را دارم ادامه سفارش کالا</span>
                   <GppGood style={{fontSize: '30px', color: '#ffffff'}}/>
                 </button>
               </div>

               {/*<div className="btnGroup_blue" style={{justifyContent: 'center'}}>*/}
               {/*  <button type="button" className="btnFill" onClick={handleOrderValidate} id="handleOrderValidate">*/}
               {/*    <span id="text">سفارش کالا</span>*/}
               {/*    <GppGood style={{fontSize: '30px', color: '#ffffff'}}/>*/}
               {/*  </button>*/}
               {/*</div>*/}
               <div className="btn-divar mt-0 mx-0 mb-2 " style={{justifyContent: 'center'}}>
                 <a href={divarCallback} className="btnFill mx-0  w-100">
                   <span>اطلاعات را ندارم بازگشت به چت دیوار</span>
                   <img src={require('../../assets/img/divar.png')} alt="divar"/>
                 </a>
               </div>

             </div>
             <div className="col-12 col-lg-3 col-xl-4"/>
           </div>
         </div>


         <Dialog
            fullScreen
            open={rulesDialog1}
            onClose={() => setRulesDialog1(false)}
            className="dialog-rules"
         >

           <div className="_closed">
             <img src={process.env.REACT_APP_SITE === 'amnito' ? '/amnito.png' : '/Logo.png'} alt=""/>

             <button type="button" onClick={() => setRulesDialog1(false)} id="closeRulesDialog1">
               <CancelIcon/>
             </button>

           </div>

           <DialogContent dividers={true}>

             <div className="container pb-5">
               <div className="row">
                 {/*<div className="col-0 col-md-3 col-lg-4"/>*/}
                 <div className="col-12 text-right">

                   <h3>قوانین امنیتو</h3>
                   <p>فروشنده گرامی توجه داشته باشید که سه درصد ارزش کالا و خدمات پستی در ازای هر سفارش تایید شده از مبلغ کالا کسر و الباقی مبلغ واریز خواهد شد. </p>
                   <p>فروشنده محترم تعطیلات رسمی جز روند زمانی ارسال محسوب نمیگردد و شرکت در قبال آن مسئولیتی ندارد.</p>


                   <p>پیشنهاد میشود قبل از ثبت سفارش حتما قوانین کامل امنیتو را مطالعه کنید!</p>

                   <Divider/>

                   <h5 className="mt-4">قوانین سفارش کالا</h5>

                   <p className="desc-dialog">پستِکس یک بازارگاه خدمات پستی و مالی است که میتوانید معامله در دیوار را بصورت خرید فروش امن و یا پرداخت در محل، با استفاده از انواع سرویس های پستی، از درب محلی که هستید تجربه نمایید.</p>

                   <Box sx={{width: '100%'}}>
                     <Tabs
                        id="tabs"
                        value={value}
                        onChange={handleChange}
                        textColor="secondary"
                        indicatorColor="secondary"
                        aria-label="secondary tabs example"
                     >
                       <Tab value="0" label="خریدار"/>
                       <Tab value="1" label="فروشنده"/>
                     </Tabs>


                     {
                       value === '0' && <>
                         <ul>
                           <li>خریدار محترم لطفاً اطلاعاتی که برای این معامله لازم میباشد را جهت شروع فرایند ارسال مرسوله تکمیل بفرمایید.</li>
                           <li>خریدار محترم مبلغی که بابت خرید کالا٬ بصورت خرید فروش امن ( امنیتو ) به حساب امانی واریز میفرمایید تا زمان تحویل مرسوله و تحویل یا عدم تحویل مرسوله در حساب امانی پستِکس باقی میماند.</li>
                           <li>خریدار محترم شما مجاز هستید در زمان تحویل مرسوله محتوای مرسوله را در زمان تحویل کنترل نمایید و در صورت عدم تطابق با آگهی از تحویل آن خودداری ننمایید.</li>
                           <li>خریدار محترم شما پس از دریافت مرسوله میتوانید در نظرسنجی کیفیت کالای خریداری شده و سرویس دریافت شده شرکت نمایید.</li>
                           <li>خریدار محترم٬ فروشنده دو روز کاری فرصت دارد تا مرسوله را برای شما ارسال نماید و چنانچه در فرصت یاد شده مرسوله ارسال نگردد وجه امانی ظرف دو روز کاری به شما مسترد خواهد گردید</li>
                           <li>توافق بر سر مبلغ کالا به عهده طرفین معامله میباشد لذا از ورود درست اطلاعات مالی و فردی
                             اطمینان حاصل بفرمایید
                           </li>
                           <li>خریدار محترم مرسوله شما در مقابل درب ورودی ساختمان و در خیابان تحویل داده خواهد شد</li>
                           <li>برای پرداخت وجه معامله کنسل شده یا کالایی که مورد تایید خریدار نمیباشد ارائه شماره شبا بنام فروشنده الزامی است و در صورت تاخیر در ارائه مسئولیت تاخیر در پرداخت بعهده خریدار میباشد.</li>
                           <li>زمان تسویه حساب مالی دو روز کاری می باشد</li>

                         </ul>
                       </>
                     }

                     {
                       value === '1' && <>
                         <ul>
                           <li>چنانچه به هر علت ٬ اعم از عدم شناسایی آدرس و یا برگشتی پس از ارسال به باجه معطله مرجوع گردد کلیه هزینه های پستی و فنی از حساب گیرنده کسر خواهد شدو ارسال مجدد و هزینه انبارداری به عهده فرستنده میباشد</li>
                           <li>فروشنده محترم لازم است کالای ارسالی مطابق آگهی منتشر شده باشد تا در نظر سنجی رضایت خریدار با نمره منفی مواجه نگردید.</li>
                           <li>فروشنده محترم تعهد غرامت ناشی از عملیات پستی بعهده پستِکس است توجه داشته باشید تشخص خسارت وارده به عهده کارشناسان خبره بیمه ای پستِکس میباشد و به میزان ارزش واقعی مرسوله تعیین خواهد شد.</li>
                           <li>فروشنده محترم مرسوله شما در مقابل درب ورودی ساختمان و در خیابان تحویل گرفته خواهد شد.</li>
                           <li>برای پرداخت وجه کالا ارائه شماره شبا بنام فروشنده الزامی است و در صورت تاخیر در ارائه مسئولیت تاخیر در پرداخت بعهده فرستنده میباشد.</li>
                           <li>فروشنده محترم کلیه مرسولاتی که از ساعت ۸ صبح دیروز تا ساعت ۸ صبح امروز ثبت میشوند، همان روز تا ساعت ۱۷ جمع آوری و در فرایند ارسال قرار می گیرند. برای روزهای تعطیل فرایند ارسال از اولین روز کاری شروع می شود.</li>
                           <li>زمان تسویه حساب مالی دو روز کاری می باشد</li>
                         </ul>
                       </>
                     }
                   </Box>

                   <div className="btnGroup_blue" style={{justifyContent: 'center'}}>
                     <button type="button" className="btnFill" onClick={handleOrderValidate} id="handleOrderValidate">
                       <span id="text">ادامه سفارش کالا</span>
                       <GppGood style={{fontSize: '30px', color: '#ffffff'}}/>
                     </button>
                   </div>
                 </div>
                 {/*<div className="col-0 col-md-3 col-lg-4"/>*/}
               </div>
             </div>

           </DialogContent>
         </Dialog>

         <Dialog
            open={rulesDialog}
            onClose={() => setRulesDialog(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="dialog-rules"
         >
           <DialogContent>
             <div className="closed">
               <button type="button" onClick={() => setRulesDialog(false)} id="closeRulesDialog">
                 <CancelIcon/>
               </button>
             </div>

             <h3>توجه!</h3>
             <span>
              درصورتی که اطلاعات از فرستنده ندارید به چت دیوار مراجعه کنید
             </span>

             <p style={{fontSize: '18px', textAlign: 'right'}}>اطلاعات لازم:</p>
             <ul>
               <li>نام و نام خانوادگی</li>
               <li>شماره تماس</li>
               <li>آدرس</li>
               <li>وزن محصول</li>
               <li>ابعاد محصول</li>
             </ul>

             <div className="container">
               <div className="row">
                 <div className="col-12 col-md-12">
                   <div className="btnGroup_blue mt-0 mx-0 mb-2" style={{justifyContent: 'center'}}>
                     <button type="button" className="btnFill  mx-0" onClick={() => setRulesDialog(false)} id="closeRulesDialog">
                       <span style={{color: '#ffffff'}}>اطلاعات را دارم ادامه سفارش کالا</span>
                       <GppGood style={{fontSize: '30px', color: '#ffffff'}}/>
                     </button>
                   </div>
                 </div>
                 <div className="col-12 col-md-12">
                   <div className="btn-divar mt-0 mx-0 mb-2 " style={{justifyContent: 'center'}}>
                     <a href={divarCallback} className="btnFill mx-0">
                       <span>اطلاعات را ندارم بازگشت به چت دیوار</span>
                       <img src={require('../../assets/img/divar.png')} alt="divar"/>
                     </a>
                   </div>
                 </div>
               </div>
             </div>

             <div className="checkBox_yellow">
               <FormControlLabel control={<Checkbox
                  checked={checkBoxNotShowPopupDivar}
                  onChange={e => {
                    setCheckBoxNotShowPopupDivar(e.target.checked)
                    localStorage.setItem('notShowPopupDivar', e.target.checked)
                  }}/>}
                                 label="دیگه این پیام رو به من نمایش نده"/>
             </div>

             <span style={{textAlign: 'right'}}>درصورت تمایل فرستنده هم میتواند ثبت سفارش کند و گیرنده از قسمت سفارشات دیگران برای من پرداخت را انجام دهد</span>

           </DialogContent>
         </Dialog>

         <Dialog
            open={videoDialog}
            onClose={() => setVideoDialog(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="dialog-rules"
         >
           <DialogContent>
             <div className="closed">
               <button type="button" onClick={() => setVideoDialog(false)} id="closeVideoDialog">
                 <CancelIcon/>
               </button>
             </div>
             <h5>ویدیو آموزشی سفارش کالا</h5>

             <video width="100%" height="350" controls>
               <source src="/amnito.mp4" type="video/mp4"/>
             </video>

           </DialogContent>
         </Dialog>

       </div>
     </>
  )

}
